export const EXCMDEVICE_DELETE_RESET = 'EXCMDEVICE_DELETE_RESET'
export const EXCMDEVICE_DELETE_SET_ERROR = 'EXCMDEVICE_DELETE_SET_ERROR'
export const EXCMDEVICE_DELETE_SET_DELETED = 'EXCMDEVICE_DELETE_SET_DELETED'
export const EXCMDEVICE_DELETE_TOGGLE_LOADING = 'EXCMDEVICE_DELETE_TOGGLE_LOADING'
